import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import TariffEditPage from '../../../components/Pages/Tariffs/Edit';

const { displayName } = config;

export default function TariffsEdit(): React.ReactNode | null {
  document.title = `${displayName}: Tariffs Edit`;

  return (
    <Layout
      title="Tariffs edit"
    >
      <TariffEditPage />
    </Layout>
  );
}
